import { render } from "./NewApiFileConfigurationModal.vue?vue&type=template&id=5df4aada&ts=true"
import script from "./NewApiFileConfigurationModal.vue?vue&type=script&lang=ts"
export * from "./NewApiFileConfigurationModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__